"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
var FormatType;
(function (FormatType) {
    FormatType["Currency"] = "currency";
    FormatType["RoundCurrency"] = "roundCurrency";
    FormatType["Seconds"] = "seconds";
    FormatType["Rate"] = "rate";
    FormatType["Float"] = "float";
    FormatType["Pixel"] = "pixel";
    FormatType["Absolute"] = "absolute";
    FormatType["HumanDuration"] = "humanDuration";
    FormatType["RoundThousands"] = "roundThousands";
    FormatType["Milliseconds"] = "milliseconds";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
const FilterFormatConfiguration = {
    currency: { formatters: ['round', 'currency'], checkRound: true, digits: 2 },
    roundCurrency: { formatters: ['round', 'currency'], checkRound: false, digits: 0 },
    seconds: { formatters: ['round'], checkRound: true, digits: 1, suffix: 's' },
    milliseconds: { formatters: ['milliseconds'], suffix: 's' },
    float: { formatters: ['float', 'thousands'], checkRound: true, digits: 0 },
    rate: { formatters: ['float', 'thousands'], checkRound: true, digits: 0, suffix: '%' },
    pixel: { formatters: ['round', 'thousands'], checkRound: false, digits: 0, suffix: ' px' },
    absolute: { formatters: ['absolute'], checkRound: false, digits: 0, suffix: '' },
    roundThousands: { formatters: ['round', 'thousands'], checkRound: false, digits: 0 },
    humanDuration: { formatters: ['humanDuration'] },
};
const Currencies = {
    EUR: { symbol: '€', format: '$1 $symbol' },
    GBP: { symbol: '£', format: '$symbol $1' },
    RUB: { symbol: '₽', format: '$1 $symbol' },
    CNY: { symbol: 'Ұ', format: '$1 $symbol' },
    JPY: { symbol: '¥', format: '$1 $symbol' },
    USD: { symbol: '$$', format: '$1 $symbol' },
    ILS: { symbol: '₪', format: '$1 $symbol' },
    BRL: { symbol: 'R$', format: '$symbol $1' },
    INR: { symbol: '₹', format: '$1 $symbol' },
    KRW: { symbol: '￦', format: '$1 $symbol' },
    CHF: { symbol: 'CHF', format: '$1 $symbol' },
    SEK: { symbol: 'SEK', format: '$1 $symbol' },
    DKK: { symbol: 'kr', format: '$1 $symbol' },
    NOK: { symbol: 'kr', format: '$1 $symbol' },
    NGN: { symbol: '₦', format: '$1 $symbol' },
};
exports.MetricFormat = {
    conversionCount: { label: 'METRIC.CONVERSION_COUNT', unit: 'UNIT.CONVERSIONS', format: FormatType.RoundThousands },
    conversionRate: { label: 'METRIC.CONVERSION_RATE', format: FormatType.Rate },
    cartAverage: { label: 'METRIC.CART_AVERAGE', format: FormatType.Currency },
    revenue: { label: 'METRIC.REVENUE', format: FormatType.RoundCurrency },
    sessionTimeAverage: { label: 'METRIC.SESSION_TIME_AVERAGE', format: FormatType.HumanDuration },
    views: { label: 'METRIC.VIEWS', unit: 'UNIT.VIEWS', format: FormatType.RoundThousands },
    visitRate: { label: 'METRIC.VISIT_RATE', format: FormatType.Rate },
    visits: { label: 'METRIC.VISITS', unit: 'UNIT.VISITS', format: FormatType.RoundThousands },
    viewsVisits: { label: 'METRIC.VIEWS_PER_VISIT', unit: 'UNIT.VIEWS_PER_VISIT', format: FormatType.Float },
    elapsedTime: { label: 'METRIC.ELAPSED_TIME', format: FormatType.Seconds },
    exitRate: { label: 'METRIC.EXIT_RATE', format: FormatType.Rate },
    scrollRate: { label: 'METRIC.SCROLL_RATE', format: FormatType.Rate },
    bounceRate: { label: 'METRIC.BOUNCE_RATE', format: FormatType.Rate },
    activityRate: { label: 'METRIC.ACTIVITY_RATE', format: FormatType.Rate },
    loadingTime: { label: 'METRIC.LOADING_TIME', format: FormatType.Seconds },
    averageRevenueAfterClick: { label: 'METRIC.REVENUE_PER_CLICK', format: FormatType.Currency },
    avgConversionAfterClick: { label: 'METRIC.CONVERSION_AFTER_CLICK', format: FormatType.Rate },
    avgConversionAfterHover: { label: 'METRIC.CONVERSION_AFTER_HOVER', format: FormatType.Rate },
    avgTransactionAfterClick: { label: 'METRIC.TRANSACTION_AFTER_CLICK', format: FormatType.Rate },
    avgTransactionAfterHover: { label: 'METRIC.TRANSACTION_AFTER_HOVER', format: FormatType.Rate },
    clickRate: { label: 'METRIC.CLICK_RATE', format: FormatType.Rate },
    timeBeforeFirstClick: { label: 'METRIC.TIME_BEFORE_FIRST_CLICK', format: FormatType.Seconds },
    hoverRate: { label: 'METRIC.HOVER_RATE', format: FormatType.Rate },
    engagementRate: { label: 'METRIC.ENGAGEMENT_RATE', format: FormatType.Rate },
    hesitation: { label: 'METRIC.HESITATION', format: FormatType.Seconds },
    hoverTime: { label: 'METRIC.FLOAT_TIME', format: FormatType.Seconds },
    clickRepetition: { label: 'METRIC.CLICK_RECURRENCE', unit: 'UNIT.CLICKS', format: FormatType.Float },
    totalClicks: { label: 'METRIC.CLICK', unit: 'UNIT.CLICKS', format: FormatType.RoundThousands },
    totalRevenueAfterClick: { label: 'METRIC.REVENUE', format: FormatType.RoundCurrency },
    averageRevenueAfterTap: { label: 'METRIC.AVERAGE_REVENUE_AFTER_TAP', format: FormatType.Currency },
    conversionAfterTap: { label: 'METRIC.CONVERSION_AFTER_TAP', format: FormatType.Rate },
    transactionAfterTap: { label: 'METRIC.TRANSACTION_AFTER_TAP', format: FormatType.Rate },
    dragFlickRate: { label: 'METRIC.DRAG_FLICK_RATE', format: FormatType.Rate },
    flickRate: { label: 'METRIC.FLICK_RATE', format: FormatType.Rate },
    dragRate: { label: 'METRIC.DRAG_RATE', format: FormatType.Rate },
    swipeRate: { label: 'METRIC.SWIPE_RATE', format: FormatType.Rate },
    dragFlickRecurrence: { label: 'METRIC.DRAG_FLICK_RECURRENCE', format: FormatType.Float },
    flickRecurrence: { label: 'METRIC.FLICK_RECURRENCE', format: FormatType.Float },
    dragRecurrence: { label: 'METRIC.DRAG_RECURRENCE', format: FormatType.Float },
    swipeRecurrence: { label: 'METRIC.SWIPE_RECURRENCE', format: FormatType.RoundThousands },
    tapRate: { label: 'METRIC.TAP_RATE', format: FormatType.Rate },
    tapRecurrence: { label: 'METRIC.TAP_RECURRENCE', format: FormatType.Float },
    timeBeforeFirstTap: { label: 'METRIC.TIME_BEFORE_FIRST_TAP', format: FormatType.Seconds },
    totalRevenueAfterTap: { label: 'METRIC.TOTAL_REVENUE_AFTER_TAP', format: FormatType.Currency },
    tapCount: { label: 'METRIC.TAP_COUNT', format: FormatType.RoundThousands },
    tapDistribution: { label: 'METRIC.TAP_DISTRIBUTION', format: FormatType.RoundThousands },
};
const Formatters = {
    milliseconds(input) {
        return (parseInt(input, 10) / 1000).toString();
    },
    round(input, digits) {
        const value = parseFloat(input);
        if (!isNaN(value)) {
            return (lodash_1.isNumber(digits) ? value.toFixed(digits) : value).toString();
        }
        return '--';
    },
    currency(input, options = {}) {
        const currency = Currencies[options.currency];
        const currencyFormat = currency ? currency.format.replace('$symbol', currency.symbol) : '$1';
        const formattedValue = Formatters.thousands(input, options);
        if (formattedValue === '') {
            return currencyFormat.replace('$1', '--').replace(/\s/g, '');
        }
        return currencyFormat.replace('$1', formattedValue);
    },
    humanDuration(input) {
        const duration = toDuration(parseFloat(input));
        const to2digits = (number) => {
            return ('0' + number).slice(-2);
        };
        if (duration.hours) {
            return duration.hours + 'h ' + to2digits(duration.minutes) + 'min ' + to2digits(duration.seconds) + 's';
        }
        else if (duration.minutes) {
            return duration.minutes + 'min ' + to2digits(duration.seconds) + 's';
        }
        return duration.seconds + 's';
    },
    absolute(input) {
        const value = Math.abs(input);
        return (!isNaN(value) ? value : '--').toString();
    },
    float(input) {
        const value = Formatters.round(input, 2);
        return Math.abs(Number.parseFloat(value)) >= 10
            ? Math.abs(Number.parseFloat(value)) >= 100
                ? Formatters.round(input, 0)
                : Formatters.round(input, 1)
            : value;
    },
    roundCurrency(input) {
        return String(input);
    },
    roundThousands(input) {
        return String(input);
    },
    seconds(input) {
        return String(input);
    },
    pixel(input) {
        return String(input);
    },
    thousands(input, options = {}) {
        const locale = (options.locale || 'en').toLocaleLowerCase();
        let value;
        if (typeof input === 'number') {
            value = input;
        }
        else {
            const decimal = input.includes('.') ? input.split('.')[1] : null;
            value = decimal ? parseFloat(input).toFixed(decimal.length) : parseFloat(input);
        }
        if (isNaN(value)) {
            return '';
        }
        let enNumberString = value.toLocaleString('en', { maximumFractionDigits: value > 10 ? (value > 100 ? 0 : 1) : 2 });
        if (!enNumberString.includes('.') && value.toString().includes('.')) {
            enNumberString = value > 10 ? (value > 100 ? enNumberString : enNumberString + '.0') : enNumberString + '.00';
        }
        const [num, digit] = enNumberString.split('.');
        if (locale.includes('en')) {
            return enNumberString;
        }
        if (locale.includes('es') || locale.includes('de')) {
            return `${num.replace(',', '.')}${digit ? '.' + digit : ''}`;
        }
        if (locale.includes('fr')) {
            return `${num.replace(',', ' ')}${digit ? ',' + digit : ''}`;
        }
        return '';
    },
};
function toDuration(seconds) {
    let hours = Math.floor(seconds / 3600);
    hours >= 1 ? (seconds = seconds - hours * 3600) : (hours = 0);
    let minutes = Math.floor(seconds / 60);
    minutes >= 1 ? (seconds = seconds - minutes * 60) : (minutes = 0);
    seconds < 1 ? (seconds = 0) : void 0;
    return { hours, minutes, seconds };
}
function format(input, type, options = {}) {
    const setting = FilterFormatConfiguration[type];
    if (!setting) {
        return Formatters[type](input, options);
    }
    const value = parseFloat(input);
    const suffix = setting.suffix || '';
    if (lodash_1.trim(input).length <= 0 || isNaN(value)) {
        if (/currency/i.test(type)) {
            return Formatters.currency('--', options);
        }
        return `--${suffix}`;
    }
    const formattedValue = setting.formatters.reduce((newValue, formatter) => {
        if (formatter === 'round') {
            const digits = !setting.checkRound || (setting.checkRound && options.round) ? setting.digits : null;
            return Formatters.round(newValue, digits);
        }
        return Formatters[formatter](newValue, options);
    }, String(value));
    return formattedValue + suffix;
}
exports.format = format;
//# sourceMappingURL=format.filters.js.map